import { Link } from "react-router-dom";
import "./footer.css";
import Fbimg from "./fb2.png";
import Linkimg from "./link1.png";
import Instaimg from "./insta.png";
import ytimg from "./yt.png";
// Import YouTube icon from react-icons (already in your package.json)
import { FaYoutube } from "react-icons/fa";

export function Footer() {
  // Social media links configuration
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/profile.php?id=61565341853931",
      icon: Fbimg,
      useImage: true,
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/indiahirings/",
      icon: Instaimg,
      useImage: true,
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/@indiahirings",
      icon: ytimg,
      useImage: true,
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/110278969/admin/dashboard/",
      icon: Linkimg,
      useImage: true,
    },
  ];

  return (
    <footer className="footer">
      {/* Main footer content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Company info column */}
          <div className="footer-column company-info w-full md:w-1/2 lg:w-1/3 px-4 mb-8 md:mb-0 flex flex-col items-center text-center md:items-start md:text-left">
            <Link to="/" className="footer-logo">
              <span className="logo-text">IndiaHirings.com</span>
            </Link>
            <p className="company-description text-left max-w-md mx-auto md:mx-0">
              India's leading job portal connecting talented professionals with
              top employers across the country.
            </p>
            <div className="contact-details w-full max-w-md mx-auto md:mx-0">
              <div className="contact-item flex md:flex-row items-center md:items-start">
                <div className="contact-icon phone mb-2 md:mb-0 md:mr-3"></div>
                <span>+91-9285522022</span>
              </div>
              <div className="contact-item md:flex-row items-center text-left md:items-start">
                <div className="contact-icon location mb-2 md:mb-0 md:mr-3"></div>
                <span>
                  Sector C-8 3rd floor, Indrapuri, Raisen Road, Bhopal (MP)-
                  462022
                </span>
              </div>
              <div className="contact-item flex md:flex-row items-center md:items-start">
                <div className="contact-icon email mb-2 md:mb-0 md:mr-3"></div>
                <a href="mailto:support@indiahirings.com">
                  support@indiahirings.com
                </a>
              </div>
            </div>

            {/* Updated Social Links Section */}
            <div className="footer-socials flex justify-center md:justify-start gap-3 mt-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="social-link"
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.useImage ? (
                    <img
                      src={social.icon || "/placeholder.svg"}
                      alt={social.name}
                    />
                  ) : (
                    <social.icon className="social-icon-react" size={24} />
                  )}
                </a>
              ))}
            </div>
          </div>

          {/* For job seekers */}
          <div className="footer-column">
            <h3 className="footer-heading">For Job Seekers</h3>
            <ul className="footer-links">
              <li>
                <Link to="/jobs">All Jobs</Link>
              </li>
              <li>
                <Link to="/resume-builder">Resume Builder</Link>
              </li>
              <li>
                <a href="/candidate-dashboard/interview-preparation">
                  Interview Preparation
                </a>
              </li>
              <li>
                <a href="/candidate-dashboard/skill-development">
                  Skill Development
                </a>
              </li>
              <li>
                <a href="/">Internship</a>
              </li>
            </ul>
          </div>

          {/* For employers */}
          <div className="footer-column">
            <h3 className="footer-heading">For Employers</h3>
            <ul className="footer-links">
              <li>
                <a href="https://employer.indiahirings.com/employer-dashboard/post-job">
                  Job Posting
                </a>
              </li>
              <li>
                <a href="https://employer.indiahirings.com/employer-dashboard/search-candidate">
                  Resume Search
                </a>
              </li>
              <li>
                <a href="https://employer.indiahirings.com">HR Policy</a>
              </li>
              <li>
                <a href="https://employer.indiahirings.com">
                  Employee Training & Self-Development Programs
                </a>
              </li>
              <li>
                <a href="https://employer.indiahirings.com/contact-us">
                  Support
                </a>
              </li>
            </ul>
          </div>

          {/* Helpful links */}
          <div className="footer-column">
            <h3 className="footer-heading">Helpful Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/core-values">Our Values</Link>
              </li>
              <li>
                <Link to="/core-values">Career</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact us</Link>
              </li>
            </ul>
          </div>

          {/* App download */}
          <div className="footer-column app-download">
            <h3 className="footer-heading">Mobile App</h3>
            <p>Download our app for a better experience</p>
            <div className="app-buttons">
              <a
                href="https://play.google.com/store"
                className="app-button google-play"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="app-button-content">
                  <span className="app-store-text">GET IT ON</span>
                  <span className="app-store-name">Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">
            Copyright © {new Date().getFullYear()} indiaHirings.com. All Rights
            Reserved. Developed by{" "}
            <span className="companyName">Yaga Technologies</span>
          </p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}